import { z } from 'zod';

export const DataplaneRegisterRequestSchema = z.object({
  csrPem: z.string().trim().min(1).describe('Certificate Signing Request'),
});
export type DataplaneRegisterRequestSchemaType = z.infer<typeof DataplaneRegisterRequestSchema>;

export const DataplaneRegisterResponseSchema = z.object({
  certificate: z.string().trim().min(1).describe('Certificate'),
  dataplaneId: z.string().trim().describe('Dataplane id'),
});

export type DataplaneRegisterResponseSchemaType = z.infer<typeof DataplaneRegisterResponseSchema>;
